import { render, staticRenderFns } from "./DigitalHumanV2.vue?vue&type=template&id=3583b852&scoped=true"
import script from "./DigitalHumanV2.vue?vue&type=script&lang=ts"
export * from "./DigitalHumanV2.vue?vue&type=script&lang=ts"
import style0 from "./DigitalHumanV2.vue?vue&type=style&index=0&id=3583b852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3583b852",
  null
  
)

export default component.exports